const restrictedShortCodes = ['info', 'help', 'stop', 'stopall', 'unsubscribe', 'cancel', 'end', 'quit', 'start'];

export {
  restrictedShortCodes,
};
